import $ from 'jquery';

$(document).ready(function() {
    $(document).on('click', '.js-filter-all-results', function() {
    	$('.b-results-filter .js-filter-item').removeClass('active');
    	$(this).toggleClass('active');
    });
    $(document).on('click', '.js-filter-item', function() {
        $(this).parents('.b-container').find('.js-filter-all-results').removeClass('active');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/results/results-filter.js